export default {
  selectedPeriod: state => state.activePeriod
};
